module.exports = __webpack_public_path__ + "assets/af0d9831fb3572d0f773280763329ad0.jpg";